import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import "styles/modal.css";

const SubjectViewModal = ({ isOpen, onClose, subject, details, loading }) => {
  if (!isOpen) return null;

  const API_BASE = "https://algoritm-api-edu.uz";

  const imageUrl = details?.imgUrl
    ? `${API_BASE}/${details.imgUrl}`
    : "https://via.placeholder.com/300x180?text=Rasm+yuklanmadi";

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="modal-backdrop"
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.85, y: 60 }}
          animate={{ scale: 1, y: 0 }}
          exit={{ scale: 0.85, y: 60 }}
          transition={{ type: "spring", stiffness: 300 }}
          className="modal-content"
          onClick={(e) => e.stopPropagation()}
          style={{
            maxWidth: "700px",
            borderRadius: "16px",
            padding: "28px",
          }}
        >
          <h3
            style={{
              margin: "0 0 24px",
              fontSize: "22px",
              fontWeight: "700",
              color: "#1f2937",
            }}
          >
            {subject?.fullName || details?.fullName || "Fan haqida"}
          </h3>

          {loading ? (
            <div style={{ textAlign: "center", padding: "60px 0" }}>
              <p>Ma'lumotlar yuklanmoqda...</p>
            </div>
          ) : details ? (
            <div className="subject-detail-view">
              {details.imgUrl && (
                <div style={{ marginBottom: "24px", textAlign: "center" }}>
                  <img
                    src={imageUrl}
                    alt={details.fullName || "Fan rasmi"}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "300px",
                      borderRadius: "12px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      objectFit: "contain",
                    }}
                    onError={(e) => {
                      e.target.src =
                        "https://via.placeholder.com/600x300?text=Rasm+yuklanmadi";
                    }}
                  />
                </div>
              )}

              <div className="detail-row">
                <span className="label">To‘liq nomi:</span>
                <span>{details.fullName || "—"}</span>
              </div>

              <div className="detail-row">
                <span className="label">Qisqa nomi:</span>
                <span>{details.shortName || "—"}</span>
              </div>

              <div className="detail-row">
                <span className="label">Kod:</span>
                <span>{details.code || "—"}</span>
              </div>

              <div className="detail-row">
                <span className="label">Slug:</span>
                <span>{details.slug || "—"}</span>
              </div>

              <div className="detail-row">
                <span className="label">Status:</span>
                <span>
                  {details.status ||
                    (details.statusId ? `ID: ${details.statusId}` : "—")}
                </span>
              </div>

              <div className="detail-row">
                <span className="label">Yaratilgan sana:</span>
                <span>
                  {details.createdDate
                    ? new Date(details.createdDate).toLocaleString("uz-UZ", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })
                    : "—"}
                </span>
              </div>

              <div
                className="detail-row"
                style={{ flexDirection: "column", alignItems: "flex-start" }}
              >
                <span className="label" style={{ marginBottom: "8px" }}>
                  Ruxsatlar:
                </span>
                <ul
                  style={{ margin: "0", paddingLeft: "20px", color: "#374151" }}
                >
                  <li>Biriktirish: {details.canAssignUser ? "Ha" : "Yo‘q"}</li>
                  <li>Bekor qilish: {details.canCancel ? "Ha" : "Yo‘q"}</li>
                  <li>Tasdiqlash: {details.canConfirm ? "Ha" : "Yo‘q"}</li>
                  <li>O'chirish: {details.canDelete ? "Ha" : "Yo‘q"}</li>
                  <li>Tahrirlash: {details.canEdit ? "Ha" : "Yo‘q"}</li>
                </ul>
              </div>

              {/* Tavsif */}
              {details.description && (
                <div
                  className="detail-row"
                  style={{ flexDirection: "column", alignItems: "flex-start" }}
                >
                  <span className="label">Tavsif:</span>
                  <p
                    style={{
                      marginTop: "8px",
                      whiteSpace: "pre-wrap",
                      lineHeight: "1.6",
                      color: "#374151",
                    }}
                  >
                    {details.description}
                  </p>
                </div>
              )}
            </div>
          ) : (
            <p
              style={{
                textAlign: "center",
                color: "#e74c3c",
                padding: "40px 0",
              }}
            >
              Ma'lumot topilmadi
            </p>
          )}

          <div
            className="modal-buttons"
            style={{ marginTop: "28px", justifyContent: "flex-end" }}
          >
            <button className="btn-cancel" onClick={onClose}>
              Yopish
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default SubjectViewModal;
